export const TYPES = {
  WorkflowsService: Symbol('WorkflowsService'),
  MembershipService: Symbol('MembershipService'),
  CompanyService: Symbol('CompanyService'),
};
